module.exports = __webpack_public_path__ + "static/media/chart2.a6366046.png";